export const NON_REAL_CLAIM_DATES = [
  "0000-00-00",
  "01-01-1900",
  "01-01-1970",
  "00-00-0000",
  "01-01-0001",
  "0001-01-01",
  "0001-01-01T00:00:00",
];

export const normalizeClaimDate = (value) => {
  if (value == null || value === "") {
    return null;
  }

  return String(value).split("T")[0];
};

export const getClaimPaymentReceivedDate = (row) =>
  normalizeClaimDate(row?.paymentReceivedDate ?? row?.PaymentReceivedDate);

export const claimCodeEndsWithZero = (claimCode) => String(claimCode ?? "").endsWith("0");

export const isRealClaimDate = (dateString) => {
  const normalized = normalizeClaimDate(dateString);
  if (!normalized || NON_REAL_CLAIM_DATES.includes(normalized)) {
    return false;
  }

  const date = new Date(normalized);
  return !Number.isNaN(date.getTime()) && date >= new Date("1970-01-01T00:00:00Z");
};

export const resolveVatClaimPayoutDate = (row) => {
  const claimCode = row?.claimCode ?? "";
  const lastTwoDigits = claimCode.slice(-2);
  const payDate = normalizeClaimDate(row?.payDate ?? row?.PayDate);
  const paymentReceivedDate = getClaimPaymentReceivedDate(row);

  if (["00", "10"].includes(lastTwoDigits)) {
    if (isRealClaimDate(paymentReceivedDate)) {
      return { kind: "date", value: paymentReceivedDate };
    }

    return { kind: "na" };
  }

  if (lastTwoDigits === "11") {
    return { kind: "preFinanced" };
  }

  if (!isRealClaimDate(payDate)) {
    return { kind: "na" };
  }

  return { kind: "date", value: payDate };
};

export const getVatClaimPayoutDateSortValue = (row) => {
  const resolved = resolveVatClaimPayoutDate(row);

  if (resolved.kind === "date") {
    const timestamp = new Date(resolved.value).getTime();
    return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
  }

  return Number.MAX_SAFE_INTEGER;
};

export const resolveExciseClaimPayoutDate = (row) => {
  const claimCode = row?.claimCode ?? "";
  const lastTwoDigits = claimCode.slice(-2);
  const paymentReceivedDate = getClaimPaymentReceivedDate(row);
  const reimbursementDate = normalizeClaimDate(row?.reimbursementDate ?? row?.ReimbursementDate);

  if (["00", "10"].includes(lastTwoDigits)) {
    if (isRealClaimDate(paymentReceivedDate)) {
      return { kind: "date", value: paymentReceivedDate };
    }

    return { kind: "na" };
  }

  if (lastTwoDigits === "11") {
    return { kind: "preFinanced" };
  }

  if (isRealClaimDate(reimbursementDate)) {
    return { kind: "date", value: reimbursementDate };
  }

  return { kind: "na" };
};

export const getExciseClaimPayoutDateSortValue = (row) => {
  const resolved = resolveExciseClaimPayoutDate(row);

  if (resolved.kind === "date") {
    const timestamp = new Date(resolved.value).getTime();
    return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
  }

  return Number.MAX_SAFE_INTEGER;
};
